export const HACKS8_POINT_OF_CONTACT = '8tips';
